module.exports = __webpack_public_path__ + "img/kfz.b12d9db4.png";